#import "../../list/BusinessUnitFields.graphql"
mutation CompanyBusinessUnitUpdate($input: CompanyBusinessUnitUpdateInput!) {
  companyBusinessUnitUpdate(input: $input) {
    companyBusinessUnit {
    ...BusinessUnitFields
  }
}
}